
export const name = "developer-docs-ui";
export const version = "dev";
